import { ResultProducts } from './ResultProducts/ResultProducts';
import Pagination from 'components/Blocks/Pagination/Pagination';
import { getEndCursor } from 'components/Blocks/Pagination/paginationHelpers';
import { DEFAULT_PAGE_SIZE } from 'config/constants';
import { mapListedProductSearchConnectionType } from 'connectors/products/Products';
import { useSearchProductsQueryApi } from 'graphql/generated';
import { mapParametersFilter } from 'helpers/filterOptions/MapParametersFilter';
import { useCurrentFilterQuery } from 'helpers/queryParams/useCurrentFilterQuery';
import { useCurrentLoadMoreQuery } from 'helpers/queryParams/useCurrentLoadMoreQuery';
import { useCurrentPageQuery } from 'helpers/queryParams/useCurrentPageQuery';
import { useCurrentSearchStringQuery } from 'helpers/queryParams/useCurrentSearchStringQuery';
import { useCurrentSortQuery } from 'helpers/queryParams/useCurrentSortQuery';
import { useGtmSearchResultsListView } from 'hooks/gtm/useGtmSearchResultsListView';
import { useListingForPagination } from 'hooks/ui/useListingForPagination';
import { useDomainConfig } from 'hooks/useDomainConfig';
import React, { RefObject } from 'react';
import { ListedProductType } from 'types/product';

type SearchProductsWrapperProps = {
    paginationScrollTargetRef: RefObject<HTMLDivElement>;
};

export const SearchProductsWrapper: FC<SearchProductsWrapperProps> = ({ paginationScrollTargetRef }) => {
    const { currencyCode } = useDomainConfig();
    const currentPage = useCurrentPageQuery();
    const currentLoadMore = useCurrentLoadMoreQuery();
    const filterQuery = useCurrentFilterQuery();
    const sortQuery = useCurrentSortQuery();
    const mappedFilter = mapParametersFilter(filterQuery);
    const currentSearchString = useCurrentSearchStringQuery();

    const [{ data, fetching }] = useSearchProductsQueryApi({
        variables: {
            endCursor: getEndCursor(currentPage, currentLoadMore, DEFAULT_PAGE_SIZE),
            filter: mappedFilter,
            orderingMode: sortQuery,
            search: currentSearchString ?? '',
        },
        pause: !currentSearchString,
    });

    const [dataItems, isLoading] = useListingForPagination<ListedProductType>(
        data?.products !== undefined ? mapListedProductSearchConnectionType(data, currencyCode).products : [],
    );

    useGtmSearchResultsListView(dataItems, currentSearchString ?? '');

    return (
        <>
            <ResultProducts
                areProductsShowed={(data?.products.totalCount ?? 0) > 0}
                fetching={fetching}
                noProductsFound={parseInt(data?.products.productFilterOptions.maximalPrice ?? '') === 0}
                products={dataItems}
            />
            <Pagination
                paginationScrollTargetRef={paginationScrollTargetRef}
                isLoading={isLoading}
                totalCount={data?.products.totalCount ?? 0}
            />
        </>
    );
};
